<template>
    <div>
        <b-card>
          <h3>User Confirmation</h3>
          <br/>
          <b-row>
            <b-col>show user selection and new users here</b-col>
          </b-row>
        </b-card>
    </div>
</template>

<script>
    export default {
      data() {
      return {
        stepComplete: false,
      }
    },
    computed: {},
    components: {},
    methods:{},

    }
</script>

<style>

</style>